import { Amplify } from "aws-amplify";
import { APIConfig, AuthConfig, StorageConfig } from "./models";

export function setupAmplify(
  authConfig: AuthConfig,
  apiConfig: APIConfig,
  storageConfig: StorageConfig,
) {
  Amplify.configure(
    {
      Auth: {
        Cognito: {
          userPoolClientId: authConfig.userPoolWebClientId,
          userPoolId: authConfig.userPoolId,
          identityPoolId: authConfig.identityPoolId,
          loginWith: {
            oauth: {
              domain: authConfig.oauth.domain,
              scopes: authConfig.oauth.scopes,
              redirectSignIn: authConfig.oauth.redirectSignIn,
              redirectSignOut: authConfig.oauth.redirectSignOut,
              responseType: authConfig.oauth.responseType,
            },
          },
        },
      },
      Storage: {
        S3: storageConfig.AWSS3,
      },
      API: {
        REST: apiConfig.endpoints.reduce((acc, endpoint) => {
          acc[endpoint.name] = {
            endpoint: endpoint.endpoint,
          };
          return acc;
        }, {}),
      },
    },
    {
      Storage: {
        S3: {
          prefixResolver: async ({ accessLevel }) => {
            if (accessLevel === "guest") {
              return "";
            } else if (accessLevel === "protected") {
              return ``;
            } else {
              return ``;
            }
          },
        },
      },
    },
  );
}
